import React, { Component } from 'react';
import { MapPin, ChevronDown, CheckCircle, PlayCircle, ChevronsRight, RotateCcw, LayoutGrid, Icon } from 'lucide-react';
import i18n from '../../../i18n';
import { Link } from 'react-router-dom';
import CategoryPillsOnline from './CategoryPillsOnline';

const current_lng = localStorage.getItem('I18N_LANGUAGE');

const SORT_OPTIONS = [
    { value: 'order', label: i18n.t('sort_by') || 'Sort by' },
    { value: 'newest', label: i18n.t('newest') || 'Newest' },
    { value: 'oldest', label: i18n.t('oldest') || 'Oldest' },
];

const TIME_FILTERS = [
    { value: 'current', label: i18n.t('active_auctions'), icon: PlayCircle, countKey: 'active' },
    { value: 'upcoming', label: i18n.t('upcoming_auctions') || 'Upcoming Auctions', icon: ChevronsRight, countKey: 'upcoming' },
    { value: 'previous', label: i18n.t('previous_auctions') || 'Previous Auctions', icon: RotateCcw, countKey: 'expired' },
];

export class AuctionFilterBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewMode: props.viewMode || 'grid',
            sortBy: props.sortBy || 'order',
            timeFilter: props.timeFilter || 'current',
            categoryFilter: props.categoryFilter || 'all',
            showTimeDropdown: false,
            showSortDropdown: false,
            showCategoryDropdown: false,
            is_cat_loading: false,

        };
        this.timeDropdownRef = React.createRef();
        this.sortDropdownRef = React.createRef();
        this.catDropdownRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(e) {
        if (this.timeDropdownRef.current && !this.timeDropdownRef.current.contains(e.target)) {
            this.setState({ showTimeDropdown: false });
        }
        if (this.sortDropdownRef.current && !this.sortDropdownRef.current.contains(e.target)) {
            this.setState({ showSortDropdown: false });
        }
        if (this.catDropdownRef.current && !this.catDropdownRef.current.contains(e.target)) {
            this.setState({ showCategoryDropdown: false });
        }
    }



    setViewMode = (mode) => {
        this.setState({ viewMode: mode });
        this.props.onViewModeChange?.(mode);
    };

    setSortBy = (value) => {
        this.setState({ sortBy: value, showSortDropdown: false });
        this.props.onSortChange?.(value);
    };

    setTimeFilter = (value) => {
        this.setState({ timeFilter: value, showTimeDropdown: false });
        this.props.onTimeFilterChange?.(value);
    };

    setCategoryFilter = (value) => {
        this.setState({ categoryFilter: value, showCategoryDropdown: false });
        this.props.onCategoryChange?.(value);
    };

    openDropdown = (name) => {
        this.setState({
            showSortDropdown: name === 'sort' ? !this.state.showSortDropdown : false,
            showTimeDropdown: name === 'time' ? !this.state.showTimeDropdown : false,
            showCategoryDropdown: name === 'category' ? !this.state.showCategoryDropdown : false,
        });
    };

    render() {
        const {
            sortBy, timeFilter, categoryFilter,
            showTimeDropdown, showSortDropdown, showCategoryDropdown,
        } = this.state;
        const { counts = {} } = this.props;

        const activeTimeLabel = TIME_FILTERS.find(f => f.value === timeFilter)?.label || i18n.t('active_auctions');
        const activeSortLabel = SORT_OPTIONS.find(f => f.value === sortBy)?.label || 'Sort by';

        return (
            <div className="af-bar">

                {/* ── Left: Sort + Category ── */}
                <div className="af-bar__left">

                    {/* Sort */}
                    <div className="af-dropdown" ref={this.sortDropdownRef}>
                        <button
                            className="af-dropdown__trigger"
                            onClick={() => this.openDropdown('sort')}
                        >
                            <span>{activeSortLabel}</span>
                            <ChevronDown size={14} className={`af-dropdown__chevron ${showSortDropdown ? 'af-dropdown__chevron--open' : ''}`} />
                        </button>
                        {showSortDropdown && (
                            <div className="af-dropdown__menu af-dropdown__menu--sort">
                                {SORT_OPTIONS.map(opt => (
                                    <button
                                        key={opt.value}
                                        className={`af-dropdown__item ${sortBy === opt.value ? 'af-dropdown__item--active' : ''}`}
                                        onClick={() => this.setSortBy(opt.value)}
                                    >
                                        {sortBy === opt.value && <CheckCircle size={16} className="af-dropdown__item-icon af-dropdown__item-icon--check" />}
                                        <span>{opt.label}</span>
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>

                    <Link to="/sellers" className="af-pill">
                        {i18n.t('sellers')}
                    </Link>

                    
                    <CategoryPillsOnline
                        categories={this.props.categories}
                        activeCategory={this.props.categoryFilter}
                        onCategoryChange={this.setCategoryFilter}
                        showCount={true}
                    />

                </div>

                {/* ── Right: Time + Sellers + Map ── */}
                <div className="af-bar__right">

                    {/* Time filter */}
                    <div className="af-dropdown" ref={this.timeDropdownRef}>
                        <button
                            className={`af-pill ${timeFilter !== 'all' ? '' : 'af-pill--active'}`}
                            onClick={() => this.openDropdown('time')}
                        >
                            {activeTimeLabel}
                            <ChevronDown size={14} className={`af-dropdown__chevron ${showTimeDropdown ? 'af-dropdown__chevron--open' : ''}`} />
                        </button>
                        {showTimeDropdown && (
                            <div className="af-dropdown__menu af-dropdown__menu--time">
                                {TIME_FILTERS.map(opt => {
                                    const IconComponent = opt.icon;
                                    const count = counts[opt.countKey] ?? '';
                                    return (
                                        <button
                                            key={opt.value}
                                            className={`af-dropdown__item ${timeFilter === opt.value ? 'af-dropdown__item--active' : ''}`}
                                            onClick={() => this.setTimeFilter(opt.value)}
                                        >
                                            <IconComponent size={20} className="af-dropdown__item-icon" />
                                            <span className="af-dropdown__item-label">
                                                {opt.label}
                                                {count !== '' && <span className="af-dropdown__item-count">({count})</span>}
                                            </span>
                                        </button>
                                    );
                                })}
                                <div className="af-dropdown__divider"></div> {/* Optional divider */}
                                <Link
                                    className='af-dropdown__item'
                                    to='/auctions'
                                >
                                    <LayoutGrid size={20} className="af-dropdown__item-icon" />
                                    <span className="af-dropdown__item-label">
                                        {i18n.t('all_auctions')}  <span className="af-dropdown__item-count">({this.props.counts?.total})</span>
                                    </span>
                                </Link>
                            </div>
                        )}
                    </div>


                    <Link to="/map" className="af-pill af-pill--outline">
                        <MapPin size={14} />
                        {i18n.t('show_maps')}
                    </Link>
                </div>
            </div>
        );
    }
}

export default AuctionFilterBar;